// Import UI Components
import Icon from '@geneui/components/Icon';
// Import Constants
import { l, PARTNER_SETTINGS, DEFAULT_SORTING, GACategoryEvents } from 'constants/common';
import { RoutesList } from 'routes';
// Import Components
import { ReactComponent as KnowledgeCenterIcon } from 'assets/images/knowledge-center-icon.svg';
// Import Enums
import { PermissionEnum, SpecialUiStyleEnum, SubscriptionSectionEnum, CreatePopoverView, ObjectTypeEnum } from 'enums';

const {
    HOMEPAGE,
    DASHBOARD,
    CAMPAIGN_CREATE,
    REALTIME_JOURNEY_CREATE,
    REPORT_CREATE,
    TEMPLATE_CREATE_EMAIL,
    TEMPLATE_CREATE_SMS,
    TEMPLATE_CREATE_HOORY,
    TEMPLATE_CREATE_INTERNAL_MESSAGE,
    TEMPLATE_CREATE_SOCIAL_TELEGRAM,
    TEMPLATE_CREATE_SOCIAL_WHATS_APP,
    TEMPLATE_CREATE_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CREATE_SOCIAL_VIBER,
    TEMPLATE_CREATE_PUSH_NOTIFICATION,
    TEMPLATE_CREATE_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_DYNAMIC_POP_UP: TEMPLATE_CREATE_DYNAMIC_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_CMS_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_CMS_BANNER,
    SEGMENT_DYNAMIC_CREATE,
    SEGMENT_STATIC_CREATE,
    SEGMENT_NON_CUSTOMER_CREATE,
    SEGMENT_COMPOSITE_CREATE,
    SEGMENT_LIST,
    TEMPLATE_LIST,
    CAMPAIGN_LIST,
    REALTIME_PROMOTIONS_LIST,
    REPORT_LIST,
    COMMUNICATION,
    CONFIGURATION,
    REPORT_COMPOSITE_CREATE,
    // ANALYTICS,
    // SETTINGS,
    ADMINISTRATION,
    REPORT_CUSTOMER_JOURNEY_CREATE,
    CLIENT_LIST,
    REALTIME_ACTION_CREATE,
    PROMOTION_TIMELINE,
    AI_SEGMENTATION,
    PREDEFINED_LIST,
    SEGMENT_PREDEFINED_CREATE,
    TEMPLATE_CREATE_PREDEFINED_EMAIL,
    TEMPLATE_CREATE_PREDEFINED_SMS,
    TEMPLATE_CREATE_PREDEFINED_INTERNAL_MESSAGE,
    TEMPLATE_CREATE_PREDEFINED_PUSH_NOTIFICATION,
    TEMPLATE_CREATE_PREDEFINED_DYNAMIC_POP_UP,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_TELEGRAM,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_VIBER,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CREATE_PREDEFINED_HOORY,
    REPORT_PREDEFINED_CREATE,
    REALTIME_JOURNEY_PREDEFINED_CREATE,
    REALTIME_ACTION_PREDEFINED_CREATE,
    KNOWLEDGE_CENTER,
    OBJECT_APPROVAL_REQUEST_LIST,
} = RoutesList;

const { GANavigationCategory, GAPredefinedCategory } = GACategoryEvents;

const NavigationList = [
    {
        routeModel: HOMEPAGE,
        icon: <Icon type="bc-icon-apps" />,
        gaEvent: GANavigationCategory.events.menuHomePage,
    },
    {
        routeModel: DASHBOARD,
        icon: <Icon type="bc-icon-dashboard" />,
        gaEvent: GANavigationCategory.events.menuDashboard,
    },
    {
        routeModel: SEGMENT_LIST,
        icon: <Icon type="bc-icon-segment" />,
        permission: PermissionEnum.ViewSegment,
        gaEvent: GANavigationCategory.events.menuSegments,
    },
    {
        routeModel: TEMPLATE_LIST,
        icon: <Icon type="bc-icon-template" />,
        permission: PermissionEnum.ViewTemplate,
        gaEvent: GANavigationCategory.events.menuTemplates,
    },
    {
        routeModel: CAMPAIGN_LIST,
        icon: <Icon type="bc-icon-campaign" />,
        permission: PermissionEnum.ViewCampaign,
        gaEvent: GANavigationCategory.events.menuCampaigns,
    },
    {
        routeModel: REALTIME_PROMOTIONS_LIST,
        icon: <Icon type="bc-icon-customer-journey" />,
        permission: PermissionEnum.ViewWorkflow,
        gaEvent: GANavigationCategory.events.menuRealtimePromotion,
    },
    {
        routeModel: REPORT_LIST,
        icon: <Icon type="bc-icon-reports" />,
        permission: [PermissionEnum.ViewCustomReport, PermissionEnum.ViewAddHocReport],
        gaEvent: GANavigationCategory.events.menuReports,
    },
    {
        routeModel: CLIENT_LIST,
        icon: <Icon type="bc-icon-indicate-users" />,
        permission: PermissionEnum.ViewSegment,
        gaEvent: GANavigationCategory.events.menuClients,
    },
    {
        routeModel: COMMUNICATION,
        icon: <Icon type="bc-icon-partner" />,
        gaEvent: GANavigationCategory.events.menuCommunications,
    },
    {
        routeModel: CONFIGURATION,
        icon: <Icon type="bc-icon-settings-bars" />,
        gaEvent: GANavigationCategory.events.menuConfiguration,
    },
    {
        routeModel: ADMINISTRATION,
        icon: <Icon type="bc-icon-auto-generate-48" />,
        permission: [PermissionEnum.CRMAdmin, PermissionEnum.CRMManager],
        gaEvent: GANavigationCategory.events.menuAdministration,
    },
    {
        routeModel: PROMOTION_TIMELINE,
        icon: <Icon type="bc-icon-timeline" />,
        subscriptionSection: SubscriptionSectionEnum.PromotionSchedulingTimeline,
        gaEvent: GANavigationCategory.events.menuPromotionTimeline,
    },
    {
        routeModel: KNOWLEDGE_CENTER,
        icon: <KnowledgeCenterIcon />,
        partnerSetting: PARTNER_SETTINGS.IsAllowKnowledgeCenter,
    },
    {
        routeModel: AI_SEGMENTATION,
        icon: <Icon type="bc-icon-AI" />,
        specialUiType: SpecialUiStyleEnum.AI,
        partnerSetting: PARTNER_SETTINGS.IsAllowAiSegmentation,
        subscriptionSection: SubscriptionSectionEnum.AISegmentationTool,
        gaEvent: GANavigationCategory.events.menuAISegmentation,
    },
    {
        routeModel: PREDEFINED_LIST,
        icon: <Icon type="bc-icon-campaign" />,
        specialUiType: SpecialUiStyleEnum.AI,
        subscriptionSection: SubscriptionSectionEnum.Predefined,
        gaEvent: GANavigationCategory.events.menuPredefined,
    },
    {
        routeModel: OBJECT_APPROVAL_REQUEST_LIST,
        icon: <Icon type="bc-icon-review" />,
        partnerSetting: PARTNER_SETTINGS.IsApprovalRequired,
        gaEvent: GANavigationCategory.events.menuObjectApproval,
        permission: [PermissionEnum.ViewCampaign, PermissionEnum.ViewWorkflow],
    },

    // TODO: pages will be implemented in future sprints there are problems related backend and UX
    // {
    //     routeModel: ANALYTICS,
    //     icon: <Icon type="bc-icon-analytic-data-rmt-36" />,
    //     permission: PermissionEnum.SuperUser,
    // },
    // {
    //     routeModel: SETTINGS,
    //     icon: <Icon type="bc-icon-settings-bars" />,
    //     permission: PermissionEnum.SuperUser,
    // },
];

const ProductsList = {
    mainProductsGroup: [
        {
            name: 'Affiliates',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'Affiliates',
            url: '',
        },
        {
            name: 'Agent System',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'AgentSystem',
            url: '',
        },
        {
            name: 'Umbrella',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'Umbrella',
            url: '',
        },
        {
            name: 'Skill Games',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'SkillGames',
            url: '',
        },
        {
            name: 'Scouting',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'Scouting',
            url: '',
        },
        {
            name: 'CMS',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'CMS',
            url: '',
        },
        {
            name: 'Agent',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'Agent',
            url: '',
        },
        {
            name: 'Fantasy Sport',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'FantasySport',
            url: '',
        },
    ],
    secondaryProductsGroup: [
        {
            name: 'Promo Tools',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'PromoTools',
            url: '',
        },
        {
            name: 'Slot Builder',
            iconClass: 'bc-icon-products-48',
            displayNameKey: 'SlotBuilder',
            url: '',
        },
    ],
};

const UserProfilePopoverViews = {
    mainView: 'mainView',
    languageView: 'languageView',
};

const CreateEntitiesList = {
    mainViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-segment',
                displayNameKey: l.Segment,
                hasChildren: true,
                contentViewKey: CreatePopoverView.SegmentView,
                permission: PermissionEnum.CreateSegment,
            },
            {
                iconClass: 'bc-icon-template',
                displayNameKey: l.Template,
                hasChildren: true,
                contentViewKey: CreatePopoverView.TemplateView,
                permission: PermissionEnum.CreateTemplate,
            },
            {
                iconClass: 'bc-icon-campaign',
                displayNameKey: l.Campaign,
                permission: PermissionEnum.CreateCampaign,
                hasChildren: false,
                routeModel: CAMPAIGN_CREATE,
            },
            {
                iconClass: 'bc-icon-customer-journey',
                displayNameKey: l.RealtimePromotion,
                hasChildren: true,
                contentViewKey: CreatePopoverView.CustomerJourneyView,
                permission: PermissionEnum.CreateWorkflow,
            },
            {
                iconClass: 'bc-icon-reports',
                displayNameKey: l.Report,
                hasChildren: true,
                contentViewKey: CreatePopoverView.ReportView,
                permission: PermissionEnum.CreateAddHocReport,
            },
        ],
    },
    templateViewChildren: {
        mainGroup: [
            {
                routeModel: TEMPLATE_CREATE_EMAIL,
                iconClass: 'bc-icon-crm-email',
                displayNameKey: l.Email,
            },
            {
                routeModel: TEMPLATE_CREATE_SMS,
                iconClass: 'bc-icon-message-closed',
                displayNameKey: l.SMS,
            },
            {
                routeModel: TEMPLATE_CREATE_INTERNAL_MESSAGE,
                iconClass: 'bc-icon-sms',
                displayNameKey: l.InternalMessage,
                partnerSetting: PARTNER_SETTINGS.IsAllowInternalMessage,
            },
            {
                iconClass: 'bc-icon-social-48',
                displayNameKey: l.Social,
                hasChildren: true,
                contentViewKey: CreatePopoverView.SocialTemplateView,
            },
            {
                routeModel: TEMPLATE_CREATE_PUSH_NOTIFICATION,
                iconClass: 'bc-icon-bell-outline',
                displayNameKey: l.Push,
                partnerSetting: PARTNER_SETTINGS.IsAllowPushNotification,
            },
            {
                routeModel: TEMPLATE_CREATE_POP_UP_NOTIFICATION,
                iconClass: 'bc-icon-pop-ups',
                displayNameKey: l.PopUp,
                partnerSetting: PARTNER_SETTINGS.IsAllowPopUp,
            },
            {
                routeModel: TEMPLATE_CREATE_DYNAMIC_POP_UP_NOTIFICATION,
                iconClass: 'bc-icon-pop-ups',
                displayNameKey: l.DynamicPopUp,
                partnerSetting: PARTNER_SETTINGS.IsAllowDynamicPopUp,
            },
            {
                routeModel: TEMPLATE_CREATE_CMS_POP_UP_NOTIFICATION,
                iconClass: 'bc-icon-pop-ups',
                displayNameKey: l.CMSPopUp,
                partnerSetting: PARTNER_SETTINGS.IsAllowCMSPopUp,
            },
            {
                routeModel: TEMPLATE_CREATE_CMS_BANNER,
                iconClass: 'bc-icon-desktop-preview',
                displayNameKey: l.CMSBanner,
                partnerSetting: PARTNER_SETTINGS.IsAllowCMSBanner,
            },
            {
                routeModel: TEMPLATE_CREATE_HOORY,
                iconClass: 'bc-icon-hoory',
                displayNameKey: l.Hoory,
                partnerSetting: PARTNER_SETTINGS.IsAllowHooryMessage,
            },
        ],
        predefinedGroup: {
            displayNameKey: l.PredefinedTemplate,
            gaEvent: GAPredefinedCategory.events.navigateTemplateList,
            routeModel: PREDEFINED_LIST,
            objectType: ObjectTypeEnum.Template,
            subscriptionSection: SubscriptionSectionEnum.Predefined,
        },
    },
    segmentViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-dynamic',
                displayNameKey: l.Dynamic,
                routeModel: SEGMENT_DYNAMIC_CREATE,
                permission: PermissionEnum.CreateSegment,
            },
            {
                iconClass: 'bc-icon-static',
                displayNameKey: l.Static,
                routeModel: SEGMENT_STATIC_CREATE,
                permission: PermissionEnum.CreateSegment,
            },
            {
                iconClass: 'bc-icon-composite',
                displayNameKey: l.Composite,
                routeModel: SEGMENT_COMPOSITE_CREATE,
                permission: PermissionEnum.CreateSegment,
            },
            {
                iconClass: 'bc-icon-non-customer',
                displayNameKey: l.NonCustomer,
                routeModel: SEGMENT_NON_CUSTOMER_CREATE,
                permission: PermissionEnum.ManageNonCustomer,
            },
        ],
        predefinedGroup: {
            displayNameKey: l.PredefinedSegment,
            gaEvent: GAPredefinedCategory.events.navigateSegmentList,
            routeModel: PREDEFINED_LIST,
            permission: PermissionEnum.ManageNonCustomer,
            subscriptionSection: SubscriptionSectionEnum.Predefined,
            objectType: ObjectTypeEnum.Segment,
        },
    },
    reportViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-reports',
                displayNameKey: l.Report,
                routeModel: REPORT_CREATE,
                permission: PermissionEnum.CreateAddHocReport,
            },
            {
                iconClass: 'bc-icon-composite-report',
                displayNameKey: l.CompositeReport,
                routeModel: REPORT_COMPOSITE_CREATE,
                permission: PermissionEnum.CreateAddHocReport,
            },
            {
                iconClass: 'bc-icon-cj-report',
                displayNameKey: l.CustomerJourneyReport,
                routeModel: REPORT_CUSTOMER_JOURNEY_CREATE,
                mandatoryPermissions: [PermissionEnum.CreateAddHocReport, PermissionEnum.ManageWorkflow],
            },
        ],
        predefinedGroup: {
            displayNameKey: l.PredefinedReport,
            gaEvent: GAPredefinedCategory.events.navigateReportList,
            routeModel: PREDEFINED_LIST,
            permission: PermissionEnum.CreateAddHocReport,
            subscriptionSection: SubscriptionSectionEnum.Predefined,
            objectType: ObjectTypeEnum.Report,
        },
    },
    customerJourneyViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-customer-journey',
                displayNameKey: l.Journey,
                routeModel: REALTIME_JOURNEY_CREATE,
                permission: PermissionEnum.CreateWorkflow,
            },
            {
                iconClass: 'bc-icon-action-compaign',
                displayNameKey: l.RealtimeActionCampaign,
                routeModel: REALTIME_ACTION_CREATE,
                permission: PermissionEnum.CreateWorkflow,
                subscriptionSection: SubscriptionSectionEnum.InstantWorkflow,
            },
        ],
        predefinedGroup: {
            displayNameKey: l.PredefinedCustomerJourney,
            gaEvent: GAPredefinedCategory.events.navigateCustomerJourneyList,
            subscriptionSection: SubscriptionSectionEnum.Predefined,
            routeModel: PREDEFINED_LIST,
            objectType: ObjectTypeEnum.Workflow,
        },
    },
    awardsViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-loyalty-point',
                displayNameKey: l.LoyaltyPoint,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-send-bonus-block',
                displayNameKey: l.CashBonus,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-bonus-complete-block',
                displayNameKey: l.CorrectionBonus,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-bonus-claim-block',
                displayNameKey: l.NFTBonus,
                partnerSetting: PARTNER_SETTINGS.IsAllowNftBonus,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-crm-free-bet',
                displayNameKey: l.FrenchFreeBet,
                permissions: [PermissionEnum.ManageFreeBetBalance],
            },
            {
                iconClass: 'bc-icon-casino-bet-block',
                displayNameKey: l.WonderWheelSpin,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-awards',
                displayNameKey: l.NftVoucherBonus,
                permissions: [PermissionEnum.MakeCorrection],
            },
            {
                iconClass: 'bc-icon-chart-border',
                displayNameKey: l.PiePoints,
                permissions: [PermissionEnum.MakeCorrection],
            },
        ],
    },
    socialTemplateViewChildren: {
        mainGroup: [
            {
                routeModel: TEMPLATE_CREATE_SOCIAL_TELEGRAM,
                iconClass: 'bc-icon-send-telegram-message-block',
                displayNameKey: l.Telegram,
            },
            {
                routeModel: TEMPLATE_CREATE_SOCIAL_VIBER,
                iconClass: 'bc-icon-viber',
                displayNameKey: l.Viber,
                partnerSetting: PARTNER_SETTINGS.IsAllowViberNotification,
            },
            {
                routeModel: TEMPLATE_CREATE_SOCIAL_WHATS_APP,
                iconClass: 'bc-icon-whatsapp',
                displayNameKey: l.WhatsApp,
                partnerSetting: PARTNER_SETTINGS.IsAllowWhatsApp,
            },
            {
                routeModel: TEMPLATE_CREATE_SOCIAL_WHATS_APP_PROVIDER,
                iconClass: 'bc-icon-whatsapp',
                displayNameKey: l.WhatsAppProvider,
                partnerSetting: PARTNER_SETTINGS.IsAllowWhatsAppProvider,
            },
        ],
    },
    createPredefinedViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-dynamic',
                displayNameKey: l.Segment,
                routeModel: SEGMENT_PREDEFINED_CREATE,
                permission: [PermissionEnum.CRMAdmin, PermissionEnum.CRMManager],
            },
            {
                iconClass: 'bc-icon-template',
                displayNameKey: l.Template,
                hasChildren: true,
                contentViewKey: CreatePopoverView.PredefinedTemplateView,
                permission: [PermissionEnum.CRMAdmin, PermissionEnum.CRMManager],
            },
            {
                iconClass: 'bc-icon-reports',
                displayNameKey: l.Report,
                hasChildren: true,
                routeModel: REPORT_PREDEFINED_CREATE,
                permission: [PermissionEnum.CRMAdmin, PermissionEnum.CRMManager],
            },
            {
                iconClass: 'bc-icon-customer-journey',
                displayNameKey: l.RealtimePromotion,
                hasChildren: true,
                contentViewKey: CreatePopoverView.PredefinedRealtimePromotionView,
                permission: [PermissionEnum.CRMAdmin, PermissionEnum.CRMManager],
            },
        ],
    },
    templatePredefinedViewChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-crm-email',
                displayNameKey: l.Email,
                routeModel: TEMPLATE_CREATE_PREDEFINED_EMAIL,
            },
            {
                iconClass: 'bc-icon-message-closed',
                displayNameKey: l.SMS,
                routeModel: TEMPLATE_CREATE_PREDEFINED_SMS,
            },
            {
                iconClass: 'bc-icon-sms',
                displayNameKey: l.InternalMessage,
                routeModel: TEMPLATE_CREATE_PREDEFINED_INTERNAL_MESSAGE,
                partnerSetting: PARTNER_SETTINGS.IsAllowInternalMessage,
            },
            {
                iconClass: 'bc-icon-social-48',
                displayNameKey: l.Social,
                hasChildren: true,
                contentViewKey: CreatePopoverView.PredefinedSocialTemplateView,
            },
            {
                iconClass: 'bc-icon-bell-outline',
                routeModel: TEMPLATE_CREATE_PREDEFINED_PUSH_NOTIFICATION,
                displayNameKey: l.Push,
                partnerSetting: PARTNER_SETTINGS.IsAllowPushNotification,
            },
            {
                iconClass: 'bc-icon-pop-ups',
                routeModel: TEMPLATE_CREATE_PREDEFINED_DYNAMIC_POP_UP,
                displayNameKey: l.DynamicPopUp,
                partnerSetting: PARTNER_SETTINGS.IsAllowDynamicPopUp,
            },
            {
                iconClass: 'bc-icon-hoory',
                routeModel: TEMPLATE_CREATE_PREDEFINED_HOORY,
                displayNameKey: l.Hoory,
                partnerSetting: PARTNER_SETTINGS.IsAllowHooryMessage,
            },
        ],
    },
    socialPredefinedViewChildren: {
        mainGroup: [
            {
                routeModel: TEMPLATE_CREATE_PREDEFINED_SOCIAL_TELEGRAM,
                iconClass: 'bc-icon-send-telegram-message-block',
                displayNameKey: l.Telegram,
            },
            {
                routeModel: TEMPLATE_CREATE_PREDEFINED_SOCIAL_VIBER,
                iconClass: 'bc-icon-viber',
                displayNameKey: l.Viber,
                partnerSetting: PARTNER_SETTINGS.IsAllowViberNotification,
            },
            {
                routeModel: TEMPLATE_CREATE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER,
                iconClass: 'bc-icon-whatsapp',
                displayNameKey: l.WhatsAppProvider,
                partnerSetting: PARTNER_SETTINGS.IsAllowWhatsAppProvider,
            },
        ],
    },
    realtimePromotionPredefinedChildren: {
        mainGroup: [
            {
                iconClass: 'bc-icon-customer-journey',
                displayNameKey: l.Journey,
                routeModel: REALTIME_JOURNEY_PREDEFINED_CREATE,
                permission: PermissionEnum.CreateWorkflow,
            },
            {
                iconClass: 'bc-icon-action-compaign',
                displayNameKey: l.RealtimeActionCampaign,
                routeModel: REALTIME_ACTION_PREDEFINED_CREATE,
                permission: PermissionEnum.CreateWorkflow,
                subscriptionSection: SubscriptionSectionEnum.InstantWorkflow,
            },
        ],
    },
};

const PredefinedListMenuRequestModel = {
    segments: {
        Filters: [
            {
                Name: 'Name',
                Comparision: 2,
                Values: [''],
            },
            {
                Name: 'DefinitionType',
                Comparision: 0,
                Values: [1],
            },
        ],
        Paging: { PageSize: 1000, PageNumber: 1 },
        Sorting: DEFAULT_SORTING,
    },
    templates: {
        Filters: [
            {
                Name: 'Name',
                Comparision: 2,
                Values: [''],
            },
            {
                Name: 'ParentTemplateId',
                Comparision: 0,
                Values: [null],
            },
            {
                Name: 'DefinitionType',
                Comparision: 0,
                Values: [1],
            },
        ],
        Paging: { PageSize: 1000, PageNumber: 1 },
        Sorting: DEFAULT_SORTING,
    },
    journeys: {
        Filters: [
            {
                Name: 'Name',
                Comparision: 2,
                Values: [''],
            },
            {
                Name: 'DefinitionType',
                Comparision: 0,
                Values: [1],
            },
        ],
        Paging: { PageSize: 1000, PageNumber: 1 },
        Sorting: DEFAULT_SORTING,
    },
};

export { NavigationList, ProductsList, UserProfilePopoverViews, CreateEntitiesList, PredefinedListMenuRequestModel };
